import { useSiteContext } from '@eti/providers';
import { useCallback } from 'react';
import { screenReadersOnlyStyles } from '../../../utils/styleUtils';
import { getDurationDateTime, getDurationLabel } from './duration-utils';

export const useDurationHTML = () => {
  const {
    language: { locale },
  } = useSiteContext();

  const getDurationHTMLElement = useCallback(
    (text: string, durationInMs: number, dataTestId: string) => {
      const datetime = getDurationDateTime(durationInMs);
      const timeLabel = getDurationLabel(locale, durationInMs);

      return `<time aria-hidden="true" data-testid="${dataTestId}" datetime="${datetime}"><bdi>${text}</bdi></time>
<span class="${screenReadersOnlyStyles}">${timeLabel}&nbsp;</span>`;
    },
    [locale],
  );

  return {
    getDurationHTML: getDurationHTMLElement,
  };
};
